import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectsFacade } from 'src/app/core/store/projects/projects.facade';

@Component({
  selector: 'app-form-field-base',
  templateUrl: './form-field-base.component.html',
  styleUrls: ['./form-field-base.component.scss'],
})
export class FormFieldBaseComponent {
  @Input() invisible: boolean;
  @Input() id: any;
  @Input() label: string;
  @Input() footerTxt: string;

  isLot = false;

  constructor(private router: Router, private projectsFacade: ProjectsFacade) {
    this.isLot = this.router.url.includes('?lot=true');
  }

  get highlightFontWeight(): Observable<string> {
    return this.projectsFacade.city$.pipe(
      map((city) => {
        const hasAgeWarning =
          city === 'CRICIÚMA' || city === 'BALNEÁRIO RINCÃO';
        return hasAgeWarning && this.isLot && this.label === 'Idade'
          ? 'bold'
          : 'normal';
      })
    );
  }
}
